import type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";
import type {
  IResearchDataDataset,
  IResearchReportUpload,
  IResearchTableList,
} from "@pulse-ui/codegen-v2/generated_ts/research";
import { api } from "../base";

export type {
  IResearchDataDataset,
  IResearchReportUpload,
  IResearchTable,
  IResearchTableList,
  IResearchGrid,
  IResearchGridColumn,
  IResearchChart,
  IResearchColumn,
  IResearchSeries,
} from "@pulse-ui/codegen-v2/generated_ts/research";

const researchEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Submits a single dataset (chart/grid config + rows) into a research table. */
    submitResearchData: build.mutation<IPulseApiResponse, IResearchDataDataset>({
      query: (body) => ({
        url: "/api/trading-ops/v1/research-data",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ResearchTables"],
    }),
    /** Uploads a research report PDF (base64) for S3 archival. */
    submitResearchReport: build.mutation<IPulseApiResponse, IResearchReportUpload>({
      query: (body) => ({
        url: "/api/trading-ops/v1/research-reports",
        method: "POST",
        body,
      }),
    }),
    getResearchTables: build.query<IResearchTableList, void>({
      query: () => ({ url: "/api/trading-ops/v1/research-tables" }),
      providesTags: ["ResearchTables"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSubmitResearchDataMutation,
  useSubmitResearchReportMutation,
  useGetResearchTablesQuery,
} = researchEndpoints;
